var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"logo",attrs:{"to":"/"}},[_vm._v(" VueUsers ")])
}
var staticRenderFns = []

export { render, staticRenderFns }